import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AffectationCaisseModal",
  tabindex: "-1",
  "aria-labelledby": "AffectationCaisseModalLabel",
  "aria-hidden": "true",
  ref: "modalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-flex justify-content-between align-items-center ps-0 pe-0 pt-0 pb-15 pb-md-25" }
const _hoisted_5 = { class: "modal-title fw-bold text-black" }
const _hoisted_6 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-md-6 mb-3form-group" }
const _hoisted_15 = { class: "d-flex justify-content-end gap-2 mt-20 mt-md-25 mt-3" }
const _hoisted_16 = { class: "btn btn-primary submit text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.selectedAffectation ? 'Réaffecter' : 'Affecter') + " une caisse ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "affectationForm",
            "validation-schema": _ctx.affectationSchema,
            onSubmit: _ctx.handleSubmit
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Utilisateur "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "userId" }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.selectedUserId,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedUserId) = $event)),
                            ($event: any) => (field.onChange($event))
                          ],
                          options: _ctx.userOptions,
                          "preserve-search": true,
                          multiple: false,
                          searchable: true,
                          placeholder: "Sélectionner l'utilisateur",
                          label: "label",
                          "track-by": "value",
                          class: _normalizeClass({ 'is-invalid': errors.length })
                        }, null, 8, ["modelValue", "options", "class", "onUpdate:modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "userId",
                          class: "text-danger"
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Caisse "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    (_ctx.selectedCaisse)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.selectedCaisse.nom,
                            disabled: ""
                          }, null, 8, _hoisted_13),
                          _createVNode(_component_Field, {
                            name: "caisseId",
                            type: "hidden",
                            value: _ctx.selectedCaisse.id
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createBlock(_component_Field, {
                          key: 1,
                          name: "caisseId"
                        }, {
                          default: _withCtx(({ field, errors }) => [
                            _createVNode(_component_Multiselect, {
                              modelValue: _ctx.selectedCaisseId,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCaisseId) = $event)),
                                ($event: any) => (field.onChange($event))
                              ],
                              options: _ctx.caissesOptions,
                              "preserve-search": true,
                              multiple: false,
                              searchable: true,
                              placeholder: "Sélectionner une caisse",
                              label: "label",
                              "track-by": "value",
                              class: _normalizeClass({ 'is-invalid': errors.length })
                            }, null, 8, ["modelValue", "options", "class", "onUpdate:modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "caisseId",
                              class: "text-danger"
                            })
                          ]),
                          _: 1
                        }))
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date d'affectation ", -1)),
                  _createVNode(_component_Field, {
                    name: "dateAffectation",
                    type: "date",
                    value: _ctx.getCurrentDate(),
                    class: "form-control shadow-none fs-md-15 text-black",
                    disabled: ""
                  }, null, 8, ["value"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateAffectation",
                    class: "text-danger"
                  })
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-6 mb-3" }, [
                  _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Statut"),
                  _createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    value: "Actif",
                    disabled: ""
                  })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                }, " Annuler "),
                _createElementVNode("button", _hoisted_16, _toDisplayString(_ctx.selectedAffectation ? 'Réaffecter' : 'Affecter'), 1)
              ])
            ]),
            _: 1
          }, 8, ["validation-schema", "onSubmit"])
        ])
      ])
    ])
  ], 512))
}